import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sellcast': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M353.4 32c52.1 0 94.7 42.6 94.7 94.6v258.8c0 52-42.6 94.6-94.7 94.6h-258.7c-52.1 0-94.7-42.6-94.7-94.7v-258.7c0-52 42.6-94.6 94.7-94.6h258.7zM303.4 348.4c27.9-48.2 11.2-110.5-37.2-138.5-18.6-10.8 0.1 0.1-18.5-10.7-25-14.4-46.2 23.3-21.6 37.5 18 10.2 0.8 0.4 18.6 10.6 27.6 16 37.2 51.8 21.3 79.4-16 27.6-51.8 37.2-79.4 21.3-18.6-10.8 0.1 0.1-18.5-10.7-10.3-6-23.6-2.4-29.5 7.9l-15.7 27.2c-12.6 21.8 19.4 53 42.3 13.2 48.3 27.7 110.3 11 138.2-37.2zM325.2 139.6c14.3-24.8-23.4-46.4-37.7-21.5l-4.8 8.4c-48.3-27.7-110.3-11-138.2 37.2-27.8 48.3-11.1 110.6 37.1 138.4 18.6 10.8-0.1-0.1 18.5 10.7 25 14.4 46.2-23.3 21.6-37.5-0.1 0-18.6-10.6-18.6-10.6-27.6-16-37.3-51.8-21.3-79.4 16-27.6 51.8-37.2 79.4-21.3 18.6 10.8-0.1-0.1 18.5 10.7 10.2 5.1 20 2.9 26.5-3.6 2.7-2.7 2-2 19-31.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sellcast.js
// module id = 1008
// module chunks = 0